/**
 * Tabblad Persona's van de leerkracht: wie er meedoen in de discussies,
 * met hun CV -- alleen-lezen. Bewerken doet de beheerder.
 */
import React, { useEffect, useState } from 'react';
import { kleur } from '../../../theme/tokens';
import { basis } from '../stijlen';
import { Portret } from '../../../components/Portret';

export function Personas({ api, apiUrl }) {
  const [personas, setPersonas] = useState([]);
  const [laden, setLaden] = useState(false);
  const [gekozen, setGekozen] = useState(null);

  useEffect(() => {
    const laad = async () => {
      setLaden(true);
      try {
        const data = await api.haalPersonas();
        if (data.success) setPersonas(data.data);
      } catch (err) { console.error('Fout:', err); }
      finally { setLaden(false); }
    };
    laad();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const bekijk = async (id) => {
    try {
      const data = await api.haalPersona(id);
      if (data.success) setGekozen(data.data);
    } catch (err) { console.error('Fout:', err); }
  };

  return (
    <div style={styles.splitView}>
      <div style={styles.listPanel}>
        <div style={styles.panelHeader}><h2>Persona's</h2></div>
        {laden ? <p>Laden...</p> : personas.length === 0 ? <p style={styles.empty}>Geen persona's.</p> : (
          <ul style={styles.list}>
            {personas.map((p) => (
              <li key={p.id} style={gekozen?.id === p.id ? styles.listItemActive : styles.listItem} onClick={() => bekijk(p.id)}>
                <span>👤 {p.naam}</span>
                {p.vast_type && <span style={styles.vastType}>{p.vast_type}</span>}
              </li>
            ))}
          </ul>
        )}
      </div>
      <div style={styles.detailPanel}>
        {gekozen ? (
          <>
            <h2>
              <Portret apiUrl={apiUrl} naam={gekozen.portret} grootte={44} stijl={styles.portretKop}
                terugval={<span style={{ marginRight: '6px' }}>👤</span>} />
              {gekozen.naam}
            </h2>
            <p style={styles.korteOmschrijving}>{gekozen.korte_omschrijving}</p>
            <div style={styles.personaGrid}>
              <div style={styles.personaInfo}><strong>Geslacht:</strong> {gekozen.geslacht || '-'}</div>
              <div style={styles.personaInfo}><strong>Leeftijd:</strong> {gekozen.leeftijd || '-'}</div>
              <div style={styles.personaInfo}><strong>Woonplaats:</strong> {gekozen.woonplaats || '-'}</div>
              <div style={styles.personaInfo}><strong>Werk:</strong> {gekozen.werk || '-'}</div>
            </div>
            <h3 style={styles.sectionHeader}>Achtergrond</h3>
            <p style={styles.personaText}>{gekozen.achtergrond}</p>
            <h3 style={styles.sectionHeader}>Persoonlijkheid</h3>
            <p style={styles.personaText}>{gekozen.persoonlijkheid}</p>
            <h3 style={styles.sectionHeader}>Spreekstijl</h3>
            <p style={styles.personaText}>{gekozen.spreekstijl}</p>
          </>
        ) : <p style={styles.empty}>Selecteer een persona</p>}
      </div>
    </div>
  );
}

const styles = {
  ...basis,
  vastType: { background: kleur.accent, color: 'white', padding: '2px 8px', borderRadius: '4px', fontSize: '11px' },
  portretKop: { verticalAlign: 'middle', marginRight: '10px' },
  korteOmschrijving: { color: kleur.stil, fontSize: '16px', marginBottom: '24px' },
  personaGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '24px', padding: '16px', background: kleur.vlak, borderRadius: '8px' },
  personaInfo: { fontSize: '14px' },
  sectionHeader: { fontSize: '14px', color: kleur.inkt, marginTop: '20px', marginBottom: '8px', paddingBottom: '4px' },
  personaText: { fontSize: '14px', lineHeight: '1.6', color: kleur.tekstZacht },
};
